/**
 * General Medicine Consultations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";

// States
const state = {
    Timelines: [],
    TrajetPatient:{},
    Timeline: {}
};

// Getters
const getters = {
    Timelines: state => {
        return state.Timelines
    },
    TrajetPatient: state => {
        return state.TrajetPatient
    },
    Timeline: state => {
        return state.Timeline
    }
};

// Actions
const actions = {

    getTimelines(context, payload) {
        function successCallback(response) {
            context.commit('getTimelinesHandler', { timelines: response.data.ligne_temps });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Timeline.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getTimelinesByDossier(context, payload) {
        function successCallback(response) {
            context.commit('getTimelinesHandler', { timelines: response.data.ligne_temps });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Timeline.patient, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getTimeline(context, payload) {
        function successCallback(response) {
            context.commit('getTimelineHandler', { timeline: response.data.timeline });
            context.commit('getMedicalFileHandler', { file: response.data.consultation.dossier });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Timeline.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getTrajetPatient(context, payload) {
        function successCallback(response) {
            context.commit('getTrajetHandler', { trajet: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Timeline.Trajet, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    createTimeline(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'trajet-patients', params: { timeline: response.data.timeline.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Timeline.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        // makeApiRequest(payload.args, apiModel.Consultation.General.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateTimeline(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'trajet-patients' });

            router.push({ name: 'trajet-patient', params: { consultation: response.data.timeline.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        let url = AppConfig.apiUrl + apiModel.Timeline.Create.url + '/' + payload.timeline;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Consultation.General.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

};

// Mutations
const mutations = {

    getTimelinesHandler(state, { timelines }) {
        // Update timeline state
        state.Timelines = timelines;
    },

    getTrajetHandler(state, { trajet }) {
        // Update TrajetPatient state
        state.TrajetPatient = trajet;
    },

    getTimelineHandler(state, { timeline }) {
        // Update timeline state
        state.Timeline = timeline;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}